import { createSlice } from "@reduxjs/toolkit";
import AuthService from "services/AuthService";

let initialState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  profile: {
    userID: "",
    firstname: "",
    middleName: "",
    lastName: "",
    nationalityID: "",
    nationalityName: "",
    birthDate: "",
    email: "",
    placeOfBirth: "",
    gender: "",
    passportNumber: "",
    dateofIssue: "",
    validuntil: "",
    personalUMID: "",
    visatypeID: "",
    status: false,
  },
  realProfile: {},
  isImposinate: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearGetUserAsyncState(state) {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFailure = false;
    },
    getUserRequest(state, action) {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFailure = false;
      state.error = initialState.error;
    },
    getUserSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.profile = action.payload;
    },
    getUserFailure(state, action) {
      state.isLoading = false;
      state.isFailure = true;
      state.error = action.payload;
    },
    imposinateUser(state, action) {
      state.realProfile = state.profile;
      state.profile = action.payload;
      state.isImposinate = true;
    },
    revertImposinateUser(state, action) {
      state.profile = action.realProfile;
      state.realProfile = {};
      state.isImposinate = false;
    },
  },
});

export const {
  getUserRequest,
  getUserSuccess,
  getUserFailure,
  clearGetUserAsyncState,
  imposinateUser,
  revertImposinateUser,
} = userSlice.actions;

// ======== Thunk Action ==========

export function getUser() {
  return async (dispatch) => {
    dispatch(getUserRequest());

    try {
      const response = await AuthService.getUser();
      const results = response?.results || {};
      dispatch(getUserSuccess(results));
    } catch (error) {
      dispatch(getUserFailure(error.message));
      throw error;
    }
  };
}

export default userSlice.reducer;
